export default __webpack_public_path__ + "static/lefafa_2_4-ad2367a50addec025c1a1ee940eb46cd.webp";